import { LogoPropsType } from './logoTypes';

export default function ApacheSoftwareFoundationShortLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg
      width="225"
      height="345"
      viewBox="0 0 225 345"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M95.7841 137.362C104.621 115.584 114.48 93.8493 125.059 74.5849C109.267 62.8945 94.1036 37.6859 87.8734 26.5171C85.6358 29.0508 84.1832 31.9689 83.5245 34.3429C77.6552 55.4643 98.5484 80.9696 81.72 71.651C67.6987 63.8859 36.126 46.8809 24.083 63.7825C37.5708 81.0551 72.8484 124.512 95.7841 137.362Z"
        fill={monochrome ? 'currentColor' : '#DD552C'}
      />
      <path
        d="M125.059 74.5849C135.31 55.9185 146.234 39.5699 157.56 27.7919C157.56 27.7919 146.264 44.0887 130.129 76.6667C139.9 79.3488 167.73 84.8522 206.493 74.8727C207.447 67.8517 202.711 60.1293 179.111 57.5439C163.703 55.8578 197.604 20.8765 173.045 4.33237C172.252 3.79731 171.473 3.3252 170.709 2.90255C169.886 2.60804 169.017 2.33826 168.088 2.09771C139.406 -5.36167 135.431 43.1108 123.985 32.6906C105.49 15.8519 93.8159 19.7862 87.8733 26.5172C94.1035 37.686 109.267 62.8945 125.059 74.5849Z"
        fill={monochrome ? 'currentColor' : '#F79A23'}
      />
      <path
        d="M72.7152 200.108C79.1901 180.777 86.979 159.057 95.784 137.363C72.8483 124.512 37.5707 81.0553 24.0829 63.7827C21.675 67.1594 20.0295 71.8693 19.4814 78.3103C16.54 112.907 52.351 138.52 45.2118 143.199C35.7684 149.388 16.9731 128.332 9.56543 141.71C20.3024 155.458 42.1734 180.298 72.7152 200.108Z"
        fill={monochrome ? 'currentColor' : '#D22128'}
      />
      <path
        d="M171.94 125.494C153.808 119.049 190.888 101.763 202.929 83.4245C204.469 81.0797 206.062 78.0492 206.494 74.8726C167.73 84.8521 139.901 79.3486 130.129 76.6666C121.776 93.5345 112.131 114.791 102.072 140.42C112.548 144.885 155.325 161.377 215.745 161.462C225.904 135.092 189.149 131.609 171.94 125.494Z"
        fill={monochrome ? 'currentColor' : '#DD552C'}
      />
      <path
        d="M79.7214 203.589C90.3761 206.898 125.68 216.783 163.173 215.295C168.21 201.702 149.379 200.376 147.845 189.475C146.657 181.04 197.403 196.563 213.731 165.892C214.557 164.34 215.201 162.877 215.745 161.463C155.325 161.377 112.548 144.885 102.072 140.42C94.7205 159.149 87.1584 180.17 79.7214 203.589Z"
        fill={monochrome ? 'currentColor' : '#D22128'}
      />
      <path
        d="M79.7214 203.588C74.9338 218.662 70.2104 234.766 65.6257 251.784C63.9994 257.818 62.3922 263.965 60.8076 270.246C96.3942 281.955 129.164 270.273 130.274 255.795C130.283 255.68 130.262 255.595 130.269 255.485C131.116 240.15 108.055 248.65 108.601 239.431C109.149 230.144 148.861 239.377 161.142 219.465C162.084 217.938 162.697 216.583 163.173 215.295C125.68 216.783 90.3761 206.898 79.7214 203.588Z"
        fill={monochrome ? 'currentColor' : '#7C297D'}
      />
      <path
        d="M9.56546 141.71C9.04666 142.648 8.57861 143.732 8.17935 145.026C1.28264 167.366 50.0503 197.377 43.4152 203.919C37.4343 209.814 29.6398 196.343 20.0284 201.907C18.975 202.519 17.9058 203.29 16.8084 204.411C5.93834 215.511 16.6381 247.486 47.4788 264.554C40.2821 288.639 33.1169 315.547 26.1029 343.687C28.6473 342.799 31.6925 341.909 32.4504 339.517C33.5884 334.854 40.6216 306.482 52.0409 267.991C52.0409 267.991 54.1251 260.107 57.9406 247.117C61.4685 235.105 66.4817 218.723 72.7153 200.108C42.1735 180.298 20.3025 155.458 9.56546 141.71Z"
        fill={monochrome ? 'currentColor' : '#7C297D'}
      />
    </svg>
  );
}
